import PropTypes from 'prop-types';
import React from 'react';

import CocsResponse from '../../records/payment/CocsResponse';
import PureRenderComponent from '../PureRenderComponent';

import config from '../../config';
import Order from '../../records/Order';
import { makeUrl } from '../../lib/APIClient';

class ThreeDSecure extends PureRenderComponent {

    formRef = React.createRef();

    static propTypes = {
        authResponse: PropTypes.instanceOf(CocsResponse).isRequired,
        deviceToken: PropTypes.string,
        currentOrder: PropTypes.instanceOf(Order),
        responseUrl: PropTypes.string.isRequired,
        onComplete: PropTypes.func.isRequired,
    };

    UNSAFE_componentWillMount () {
        window.addEventListener('message', this._handleComplete);
    }

    componentWillUnmount () {
        window.removeEventListener('message', this._handleComplete);
    }

    componentDidMount () {
        // Once rendered onto the page, we submit the
        // 3DSecure form through the iframe immediately
        this.formRef.current.submit();
    }

    _handleComplete = ({ origin, data }) => {
        if (window.location.href.includes(origin.replace(/^https?:/, '')) && data === 'complete') {
            this.props.onComplete();
        }
    };

    render () {
        const { authResponse, currentOrder, isOrderAmendment, responseUrl } = this.props;
        const isThreeDSecureV2 = !!authResponse.threeDSServerTransId;

        const { host } = window.location;
        const callbackUrl = config.get('threeDSecureCallbackUrl');

        const threeDSecureTermUrl = isThreeDSecureV2
            ? config.get('threeDSecureTermUrlV2Payment')
            : config.get('threeDSecureTermUrlV1Payment');

        const responseUrlValue = isOrderAmendment ?
            makeUrl(threeDSecureTermUrl
                .replace('{orderId}', currentOrder.id)
                .replace('{paymentId}', authResponse.id)
                .replace('{deviceToken}', this.props.deviceToken)
                .replace('{callbackUrl}', `https://${host}${callbackUrl}`))
            : responseUrl;

        return (
            <form
                className="embed-responsive threed-secure"
                ref={this.formRef}
                action={authResponse.redirect}
                method="POST"
                target="iframe"
            >
                <iframe ref="iframe" name="iframe" className="js-3ds-iframe" frameBorder="0" />
                {isThreeDSecureV2 ? (
                    <React.Fragment>
                        <input
                            type="hidden"
                            name="transactionId"
                            value={authResponse.threeDSServerTransId}
                        />
                        <input type="hidden" name="notificationUrl" value={responseUrlValue} />
                        <input type="hidden" name="MD" value={authResponse.md} />
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <input type="hidden" name="PaReq" value={authResponse.pareq} />
                        <input type="hidden" name="MD" value={authResponse.md} />
                        <input type="hidden" name="TermUrl" value={responseUrlValue} />
                    </React.Fragment>
                )}
            </form>
        );
    }

}

export default ThreeDSecure;



// WEBPACK FOOTER //
// ./src/components/payment/ThreeDSecure.js